"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemeProviderLib = function ThemeProviderLib(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, children);
};

ThemeProviderLib.propTypes = {
  children: (0, _propTypes.shape)().isRequired,
  theme: (0, _propTypes.shape)().isRequired
};
var _default = ThemeProviderLib;
exports.default = _default;